module.exports = __webpack_public_path__ + "static/img/img_map_05.9b20fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_map_05.png
// module id = Ux7s
// module chunks = 2